'use client';

import React from 'react';
import { Toast } from './Toast';
import './ToastContainer.scss';

const ALL_POSITIONS = [
  'top-left', 
  'top-right', 
  'bottom-left', 
  'bottom-right',
  'top-center',
  'bottom-center',
];

export function ToastContainer({ toasts, removeToast }) {
  return (
    <>
      {ALL_POSITIONS.map((pos) => {
        const group = toasts.filter((toast) => toast.position === pos);
        if (group.length === 0) return null;

        return (
          <div key={pos} className={`toast-container ${pos}`}>
            {group.map((toast) => (
              <Toast
                key={toast.id}
                message={toast.message}
                type={toast.type}
                duration={toast.duration}
                position={toast.position}
                onClose={() => removeToast(toast.id)}
              />
            ))}
          </div>
        );
      })}
    </>
  );
}
